// UtilityPopup.js
import React from 'react';
import { ImagePath } from '../helper/ImagePath';

const UtilityPopup = ({ isOpen, onClose, onConfirm, url, image }) => {

    if (!isOpen) return null;

    return (
        <div className="webinar-popup-overlay">
            <div className="webinar-popup-content">
                <span className='webinar-popup-close' onClick={onClose}>
                    <img className="" src={ImagePath.webinarPopupClose} alt="close" />
                </span>
                <a href={url} target='_blank' rel="noopener noreferrer" className='d-block'>
                    <img className="img img-fluid w-100" src={image} alt="user" />
                </a>

            </div>
        </div>
    );
};

export default UtilityPopup;
